import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import "./i18n"; // ✅ مرة واحدة فقط

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import i18n from "i18next"; // ✅ نفس instance اللي تم تهيئته في ./i18n

// 🔥 ضبط الاتجاه + lang بشكل دائم حسب اللغة الحالية
const BUILD_MARKER = "WebView-Call-Only-No-Native-Zego";
console.log(`[buildMarker] ${BUILD_MARKER}`);
console.log("[bootCheck] React boot ok");

const RTL_LANGS = ["ar", "fa", "he"];

function applyDirAndLang(lang) {
  const dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lang);
}

// أول تحميل
applyDirAndLang(i18n.language || "en");

// كل ما تتغير اللغة
i18n.on("languageChanged", (lng) => {
  applyDirAndLang(lng || "en");
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
